import { render, staticRenderFns } from "./library.vue?vue&type=template&id=2654b195"
import script from "./library.vue?vue&type=script&lang=js"
export * from "./library.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports